<template>
    <div style="width:350px"  v-loading="fullscreenLoading">           
        <el-form autocomplete="off" size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <el-col :span="22">
            <el-form-item label="商户名称" prop="age" >
               <span>{{ruleForm.userName}}</span>
            </el-form-item>
            <el-form-item label="登录名" prop="pass" >
               <span>{{ruleForm.loginId}}</span>
            </el-form-item>
            <el-form-item label="手机号" prop="pass" >
                <span>{{ruleForm.mobileNo}}</span>
            </el-form-item>
            <el-form-item label="密码" prop="pass" >
                <span>*********</span>
            </el-form-item>
            <el-form-item label="上次登录时间" prop="age" >
               <span>{{ruleForm.lastLoginTs|formatDate('yyyy年MM月dd日 hh时mm分ss秒')}}</span>
            </el-form-item>
            <el-form-item label="注册时间" prop="pass" >
                <span>{{ruleForm.registerTs|formatDate('yyyy年MM月dd日 hh时mm分ss秒')}}</span>
            </el-form-item>
            </el-col>
            <el-col :span="2">
            <el-form-item>
                <br>
            </el-form-item>
            <el-form-item>
                <br>
            </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="edite">修改</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="editpass">修改</el-button>
            </el-form-item>
            </el-col>
          </el-row>      
        </el-form>
    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
export default {
  created() {
    this.load();
  },
  data() {
    return {
      fullscreenLoading: false,
      ruleForm: {},
      rules: {}
    };
  },
  methods: {
    ...mapMutations({
      addd: "add"
    }),
    edite() {
      this.addd({
        menuUrl: "editphone",
        menuNm: "修改手机号",
        iconName: "editphone"
      });
    },
    editpass() {
      this.addd({
        menuUrl: "editPw",
        menuNm: "修改密码",
        iconName: "editPw"
      });
    },
    load() {
      this.fullscreenLoading = true;
      this.$http.post("/w/user/manage").then(
        data => {
          this.ruleForm = data.data;
          this.fullscreenLoading = false;
        },
        err => {
          this.fullscreenLoading = false;
        }
      );
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/view/page/Account/Account.vue